





































































































import { Student } from '../../../src_server/entity/generated/Student';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { InputPages } from '../../components/organisms/InputPages';
import { prefecturesOptions } from '../../../src_server/entity/master/prefecturesData';
import historykana from 'historykana';
import { ZipCodeService } from '../../biz/remote/ZipCodeService';
import { MessageDialog } from '../../utils/MessageDialog';
import ErrorSummary from '../../components/inputs/ErrorSummary.vue';
import { TextValidate } from '../../components/inputs/TextValidate';

@Component({ components: { ErrorSummary } })
export default class StudentParentInfoPage extends InputPages {
  @Prop()
  value!: Student;

  private emailReg = TextValidate.EMAIL_REGX;

  get model() {
    return this.value;
  }

  set model(value) {
    this.value = value;
  }

  get prefectures() {
    return prefecturesOptions;
  }

  // @Watch('model.zip_code')
  async zip() {
    console.log('zip', this.model.zip_code);
    const res = await new ZipCodeService().zipCode(this.model.zip_code || '');
    const results = res.data.results;
    if (results && results[0]) {
      const result = results[0];
      await MessageDialog.alert(`${this.model.zip_code}に対応する住所${result.address1}${result.address2}${result.address3}をセットしました`);
      this.model.prefecture = result.address1; // 都道府県
      this.model.city_name = result.address2; // 市区町村
      this.model.address_line1 = result.address3; // 町域
    }
  }

  private keyHistory: string[] = [];
  // inputName(e: Event) {
  //   const key = (e.target as HTMLInputElement).value;
  //   if (key === '') {
  //     this.keyHistory = [];
  //   }
  //   this.keyHistory.push(key);
  //   this.model.parent_full_name_kana = historykana(this.keyHistory);
  // }
}
